import React, { useState, useEffect } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles'


const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const ItemFeature = ({itemId, feature, itemData, onBackToItem, onSuccess}) => {
    const [search, setSearch] = useState("");

    const formattedData = itemData.map((item, index) => ({
      id: index + 1,
      ...item
    }));

    const filteredData = formattedData.filter((item) =>
      [item?.name, item?.qty]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );

    const columns = [
      { name: "No", selector: (row) => row.id, width: "70px",style: { display: "flex", justifyContent: "center", alignItems: "center" }, sortable: true },
      { name: "Name", selector: (row) => row.name, sortable: true, minWidth: "100px", maxWidth: "400px"},
      { name: "Qty", selector: (row) => row.qty, sortable: true, minWidth: "50px", maxWidth: "100px"},
            { 
        name: "Image",
        minWidth: "100px",
        maxWidth: "250px",
        grow:2,
        cell: (row) => (
          <img 
            src={`${process.env.REACT_APP_API}/images/${row.image_url}`} 
            alt="Bank Image" 
            style={{ width: "80px", height: "auto", objectFit: "contain" }}
          />
        )
      },
      { 
        name: "Action", 
        minWidth: "100px", 
        maxWidth: "150px",
        style: { display: "flex", justifyContent: "center", alignItems: "center" },
        cell: (row) => (
          <div>
              <button 
                class="btn btn-sm rounded-circle btn-warning me-2" // Tambahkan margin agar tidak berdempetan
                onClick={() => handleEditFeatureItem(row)}
              >
                <i class='bx bx-edit' style={{color:"white"}}></i>
              </button>

              <button 
                class="btn btn-sm rounded-circle btn-danger me-2"
                onClick={() => handleDeleteFeatureItem(row)}
              >
                <i class='bx bx-trash'></i>
              </button>
            </div>
        )
      }
    ];

    const [mode, setMode] = useState("add");
    const [selectedFeatureItem, setSelectedFeatureItem] = useState(null);
    const [formData, setFormData] = useState({
      item_id: itemId,
      feature_id: "",
      qty: "",
    });

    useEffect(() => {
      if (mode === "edit" && selectedFeatureItem) {
        setFormData(selectedFeatureItem);
      } else if (itemId) {
        setFormData({
          item_id: itemId,
          feature_id: "",
          qty: "",
        });
      }
    }, [mode, selectedFeatureItem, itemId]);
  
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      try {
        if (mode === "add") {
          const response = await axios.post(
            `${process.env.REACT_APP_API}/feature-item/add`,
            {
              item_id: formData.item_id,
              feature_id: formData.feature_id,
              qty: formData.qty
            }
          );
          if (response.status === 201) {
            showSuccess("Feature Item berhasil ditambahkan");
            if (onSuccess) onSuccess(formData.item_id);
            setFormData({
              item_id: itemId,
              feature_id: "",
              qty: "",
            });
          } else {
            showError("Gagal menambahkan Feature Item");
          }
        } else {
          const response = await axios.put(
            `${process.env.REACT_APP_API}/feature-item/${formData.feature_item_id}`,
            {
              feature_item_id: formData.feature_item_id,
              item_id: formData.item_id,
              feature_id: formData.feature_id,
              qty: formData.qty
            }
          );
          if (response.status === 200) {
            showSuccess("Feature Item berhasil diperbarui");
            if (onSuccess) onSuccess(formData.item_id);
            setMode("add");
          } else {
            showError("Gagal memperbarui Feature Item");
          }
        }
      } catch (error) {
        console.error("Error:", error.response?.data || error.message);
        showError(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
      }
    };
  
    const handleEditFeatureItem = (item) => {
      setMode("edit");
      setSelectedFeatureItem(item);
    };

    const handleAddFeatureItem = () => {
      setMode("add");
      setSelectedFeatureItem("");
    };

    const handleDeleteFeatureItem = async (item) => {
      try {
        const confirmed = await showConfirm({
          title: 'Hapus Feature Item',
          text: `Apakah Anda yakin ingin menghapus Feature Item ${item.name}?`,
          confirmButtonText: 'Hapus'
        });
        if (!confirmed) return;
        if (!item?.feature_item_id) {
          alert("Feature Item ID tidak ditemukan");
          return;
        }

        const response = await axios.delete(
          `${process.env.REACT_APP_API}/feature-item/${item.feature_item_id}`
        );

        if (response.status === 200 || response.status === 201) {
          showSuccess(response.data.message || "Feature Item berhasil dihapus");
          if (onSuccess) onSuccess(item.item_id);
        } else {
          showError(response.data.message || "Gagal menghapus Feature Item");
        }
      } catch (error) {
        console.error("Error deleting Feature Item:", error);
        showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Feature Item");
      }
    };

  return (
    <div class="row">
      <div class="col-lg-5">
      <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div class="form-group mb-3">
            <label for="feature_id" class="form-label">Pilih Feature</label>
            {mode === "edit" ? (
              <select
                class="form-select"
                name="feature_id"
                value={formData.feature_id}
                disabled
              >
                <option value={formData.feature_id}>
                  {
                    feature.find(fea => fea.feature_id === formData.feature_id)?.name || "Feature Terpilih"
                  }
                </option>
              </select>
            ) : (
              <select
                class="form-select"
                name="feature_id"
                value={formData.feature_id}
                onChange={handleChange}
                required
              >
                <option value="" hidden>--- Pilih Feature ---</option>
                {feature.map(fea => (
                  <option key={fea.feature_id} value={fea.feature_id}>
                    {fea.name}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div class="form-group mb-3">
            <label for="qty" class="form-label">Qty</label>
            <input 
              class="form-control"
              type="text" 
              name="qty"
              placeholder="Isi qty"
              value={formData.qty}
              onChange={handleChange}
              required
            />
          </div>

          <button type="button" class="btn btn-primary me-2" onClick={onBackToItem}>
            Back To Item
          </button>

          {mode === "edit" && (
            <button type="button" class="btn btn-secondary me-2" onClick={handleAddFeatureItem}>
              Back To Add
            </button>
          )}

          <button type="submit" class="btn btn-success">
            {mode === "add" ? "Save" : "Update"}
          </button>
        </form>
      </div>

      
      <div class="col-lg-7 mb-4">
          <div class="d-flex justify-content-end align-items-center mb-2">
                  <input
                  type="text"
                  placeholder="Search..."
                  class="form-control w-100"
                  style={{ maxWidth: "200px" }}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  />
          </div>

          <div class="datatable-container">
              <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover={false}
              customStyles={DatatableStyles}
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 25]}
              paginationComponentOptions={paginationOptions}
              responsive
              />
          </div>
      </div>
    </div>
  );
};

export default ItemFeature;
